import { throttle } from 'lodash-es';
import { useEffect, useRef } from 'react';

export const useWindowScrollHandler = (callback: () => any) => {
  const lastScrollY = useRef(0);
  // biome-ignore lint/correctness/useExhaustiveDependencies: Do not add `callback` to dependency - callback can be defined in every render.
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handlePageScroll = throttle(() => {
      if (lastScrollY.current !== (window.scrollY ?? 0)) {
        lastScrollY.current = window.scrollY ?? 0;

        callback();
      }
    }, 800);

    window.addEventListener('scroll', handlePageScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handlePageScroll);
    };
  }, []);
};
